import {createContext, use, useEffect, useRef} from 'react'

import type {CopilotUiReadinessView} from './copilot-ui-readiness'

export const CopilotUiReadinessContext = createContext<CopilotUiReadinessView | undefined>(undefined)

export function useCopilotUiReadiness() {
  return use(CopilotUiReadinessContext)
}

export function useCopilotUiReadinessLifetime(view: CopilotUiReadinessView | undefined, disposeReason?: 'replaced') {
  const mountedViewRef = useRef<CopilotUiReadinessView | undefined>(undefined)
  useEffect(() => {
    if (!view) return
    mountedViewRef.current = view
    return () => {
      view.controlsUnavailable()
      mountedViewRef.current = undefined
      // StrictMode replays effects synchronously without ending the logical open.
      queueMicrotask(() => {
        if (mountedViewRef.current !== view) view.dispose(disposeReason)
      })
    }
  }, [view, disposeReason])
}
